const handleBrokenImage = (event: Event) => {
  const target = event.target as HTMLImageElement;

  if (target && target.src !== '') {
    target.src = new URL('/resources/images/property-image-unavailable-01.png', import.meta.url).href;
  }
};

export default handleBrokenImage;
